import React, { useEffect, useState } from 'react';
import { Tab, Tabs } from 'react-bootstrap';
import Loader from '../../components/Loader';
import smartHttp from '../../helpers/smartHttp';
import { useNavigate } from 'react-router-dom';
import MultiSelectDropdown from '../../sharedcomponents/multi-select-dropdown/multi-select-dropdown';
import CommonDropdown from '../../sharedcomponents/CommonDropdown/CommonDropdown';
import {
  Endpoints,
  userPreferencesKey,
  UrlPath,
  ContractDisplayOptions,
  PersistReduxAction,
  viewerUserGroup,
  superUserGroup,
  csaUserGroup,
  exhibitUserGroup,
  Cancelled,
} from './../../constants';
import Locations from './../locations/locations';
import UserDetails from './user-details';
import LocationMapping from './LocationMapping';
import ExportUsers from './export-users/ExportUsers';
import store from './../../redux/store';
import persistDataStore from './../../redux/persistStore';
import { useSelector, useDispatch } from 'react-redux';
import { addContract } from './../../redux/actions';
import {
  getCSAContractsData,
  updateVirtualContractsData,
} from './../../helpers/component-helper-methods';

const UserLocationContainer = () => {
  const [loading, setLoading] = useState(true);
  const [dropDownLoader, setDropDownLoader] = useState(true);
  const [breadCrumbValue, setBreadCrumbValue] = useState();
  const [contractsResult, setContractsResult] = useState([]);
  const [accountsData, setAccountsData] = useState([]);
  const [activeTab, setActiveTab] = useState();
  const [contractDisplayOption, setContractDisplayOption] = useState();
  const [isViewerUser, setIsViewerUser] = useState(false);
  const [isCSAUser, setIsCSAUser] = useState(false);
  const [isBPMReferral, setIsBPMReferral] = useState(false);
  const [totalUserCount, setTotalUserCount] = useState();
  const [totalLocationCount, setTotalLocationCount] = useState();
  const [showContractDropdown, setShowContractDropdown] = useState(true);
  const [locationFilter, setLocationFilter] = useState(null);
  const [showLocationMapping, setShowLocationMapping] = useState(false);
  const [oldLocationsData, setOldLocationsData] = useState([]);
  const [oldLocationsContractNumbers, setOldLocationsContractNumbers] = useState([]);
  const usersTabName = 'users';
  const locationsTabName = 'locations';
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const callBackTotalUsers = (props) => setTotalUserCount(props);
  const callBackLocationUsers = (props) => setTotalLocationCount(props);

  const onLocationUserCountClick = (locationName) => {
    setLocationFilter(locationName);
    setActiveTab(usersTabName);
  };

  useEffect(() => {
    (async () => {
      let storeData = store.getState();
      let storeUserInfo = storeData?.userInfo;

      if (storeUserInfo && storeUserInfo.userInfo) {
        setIsViewerUser(
          storeUserInfo.userInfo.SPGGroups?.includes(viewerUserGroup) &&
            !storeUserInfo.userInfo.SPGGroups?.includes(csaUserGroup) &&
            !storeUserInfo.userInfo.SPGGroups?.includes(superUserGroup),
        );
        setIsCSAUser(
          storeUserInfo.userInfo.SPGGroups?.includes(superUserGroup) ||
            storeUserInfo.userInfo.SPGGroups?.includes(csaUserGroup),
        );
        // FEATURE DISABLED (Release july-2026) - Exhibit persona / BPM Referral cloning
        // const isExhibitUser = storeUserInfo.userInfo.SPGGroups?.includes(exhibitUserGroup);
        // setIsBPMReferral(!!isExhibitUser);
        // if (isExhibitUser) {
        //   setBreadCrumbValue('');
        //   setShowContractDropdown(false);
        //   const userContracts = storeData?.userContracts?.userContracts;
        //   const exhibitContractNumber = userContracts?.[0]?.contractNumber;
        //   if (exhibitContractNumber) {
        //     const ccaData = { type: 'contract', data: null, value: exhibitContractNumber };
        //     persistDataStore.dispatch({ type: PersistReduxAction.csaActionData, payload: ccaData });
        //   }
        // }
        const isExhibitUser = false; // FEATURE DISABLED (Release july-2026)
        await getContractDisplayOption(storeUserInfo.userInfo.userPreferences);
        getContractsDataSet(storeUserInfo.userInfo.email, isExhibitUser);
      }
    })();
  }, [useSelector((x) => x.userInfo)]);

  // set header breadcrumb to CSA selected value
  useEffect(() => {
    let csaActionData =
      persistDataStore.getState()?.userActionData?.csaUserActionInfo;
    let breadCrumbData =
      csaActionData?.type === 'account'
        ? csaActionData?.data?.account
        : csaActionData?.type === 'hccompany'
        ? csaActionData?.data?.homogenizedCompany
        : csaActionData?.value;
    setBreadCrumbValue(breadCrumbData);
  }, []);

  const getContractsDataSet = async (userEmail, isDigitizationUser = false) => {
    let csaActionData =
      persistDataStore.getState()?.userActionData?.csaUserActionInfo ?? {};
    userEmail = userEmail.toLowerCase();
    let queryParamsContract = {};
    let selectedUserContracts = [];
    if (localStorage.hasOwnProperty('CSASelectedUserContracts')) {
      selectedUserContracts = localStorage
        .getItem('CSASelectedUserContracts')
        .split(',');
      queryParamsContract = {
        PageSize: 5000,
        Field:
          'contractNumber,HomogenizedCompany,contractType,contractDescription,bulkEntitlementEnable',
      };
    } else {
      queryParamsContract = {
        PageSize: 5000,
        Field:
          'contractNumber,contractType,HomogenizedCompany,contractDescription,bulkEntitlementEnable,isVirtualContract,mappedContractNumber,contractStatus',
        Filter: `email:"${userEmail}"`,
      };
    }

    // Filter out Cancelled contracts for non-super users
    const userGroups = store.getState()?.userInfo?.userInfo?.SPGGroups || [];
    const isSuperUser = userGroups.includes(superUserGroup);
    if (!isSuperUser && queryParamsContract.Filter) {
      queryParamsContract.Filter += ` and contractStatus!:"${Cancelled}"`;
    }

    try {
      let storeData = store.getState();
      let storeContracts = storeData.contract;

      if (storeContracts?.contracts?.length > 0) {
        let storedContract = [...storeContracts.contracts];
        setContractsResult(storedContract);
      } else {
        if (csaActionData?.type && csaActionData?.value) {
          let csaContracts = await getCSAContractsData();
          setDropDownLoader(false);
          // Dispatch contracts to Redux first - this filters out suspended contracts for CCA/End Users
          dispatch(addContract(csaContracts));
          // Now read back the filtered contracts from Redux store to keep local state in sync
          const filteredContracts = store.getState()?.contract?.contracts || [];
          setContractsResult(filteredContracts);
        } else {
          const contractResponse = await smartHttp.get(
            Endpoints.contractApi,
            queryParamsContract,
          );
          let tempState = contractResponse.data?.results?.map((el, i) => {
            return {
              label:
                el.contractNumber +
                (el.contractDescription ? ' - ' + el.contractDescription : ''),
              id: el.contractNumber,
              checked: true,
              bulkEntitlementEnable: el.bulkEntitlementEnable,
              homogenizedCompany: el.homogenizedCompany,
              ...el,
            };
          });
          // Filter for distinct contractNumbers
          const distinctContracts = tempState.reduce((acc, current) => {
            const existingContract = acc.find(
              (item) => item.contractNumber === current.contractNumber,
            );
            if (!existingContract) {
              acc.push(current);
            }
            return acc;
          }, []);
          tempState = updateVirtualContractsData(distinctContracts);
          setContractsResult(tempState);
          tempState = updateVirtualContractsData(tempState);
          // Dispatch contracts to Redux first - this filters out suspended contracts for CCA/End Users
          dispatch(addContract(tempState));
          // Now read back the filtered contracts from Redux store to keep local state in sync
          const filteredContracts = store.getState()?.contract?.contracts || [];
          setContractsResult(filteredContracts);
        }
      }
      if (isDigitizationUser) {
        const contracts = store.getState()?.contract?.contracts || [];
        await fetchOldLocations(contracts);
      }
    } catch (err) {
    } finally {
      setDropDownLoader(false);
      setLoading(false);
      // FEATURE DISABLED (Release july-2026) - Exhibit persona check
      // const isExhibitUser = storeUserInfo?.SPGGroups?.includes(exhibitUserGroup);
      // if (!isExhibitUser) {
      if (true) { // FEATURE DISABLED - always run non-exhibit path
        let storeData = store.getState();
        let storeContracts = storeData.contract;
        setShowContractDropdown(!storeContracts?.isVirtualContract);
      }
    }
  };

  const fetchOldLocations = async (contracts) => {
    try {
      const queryParamsContract = {
        PageSize: 5000,
        Filter: `contractNumber in (${contracts
          .map((data) => (data ? '"' + data.contractNumber + '"' : ''))
          .join(',')})`,
      };
      const resp = await smartHttp.getRapid(Endpoints.getOldLocationsApi,queryParamsContract);
      const oldLocs =
        resp?.data?.results ??
        (Array.isArray(resp?.data) ? resp.data :[]);
      if (oldLocs.length > 0) {
        const contractNumbers = contracts
          .map((c) => c.contractNumber || c.id)
          .filter(Boolean);
        setOldLocationsData(oldLocs);
        setOldLocationsContractNumbers(contractNumbers);
        setShowLocationMapping(true);
      }
    } catch {
        Notify({
          alert: true,
          type: 'error',
          title: GenericError.somethingWentWrong,
        });
    }
  };

  const getContractLabelKey = () => {
    if (contractDisplayOption) {
      if (
        contractDisplayOption.preferenceValue ===
        ContractDisplayOptions[1].contractDisplayOption
      ) {
        return 'contractDescription';
      }
      if (
        contractDisplayOption.preferenceValue ===
        ContractDisplayOptions[2].contractDisplayOption
      ) {
        return 'label';
      }
    }

    return 'contractNumber';
  };

  const getContractDisplayOption = async (userPreferences) => {
    try {
      if (
        userPreferences?.find(
          (x) => x.preferenceKey === userPreferencesKey['displayContract'],
        )
      ) {
        setContractDisplayOption(
          userPreferences.find(
            (x) => x.preferenceKey === userPreferencesKey['displayContract'],
          ),
        );
      } else {
        setContractDisplayOption({
          preferenceValue: ContractDisplayOptions[0].contractDisplayOption,
        });
      }
    } catch (err) {}
  };

  useEffect(() => {
    const reduceCallback = setTimeout(() => {
      getAccounts();
    }, 800);
    return () => clearTimeout(reduceCallback);
  }, [contractsResult]);

  const selectedCount = contractsResult?.reduce(
    (counter, obj) => (obj.checked === true ? (counter += 1) : counter),
    0,
  );

  const getAccounts = () => {
    if (contractsResult && contractsResult.some((x) => x.checked)) {
      let queryParams = {
        pageSize: 5000,
        field: 'accountId,accountName',
        Filter: `contractNumber in(${contractsResult
          .filter((x) => x.checked)
          .map((t) => (t.id ? '"' + t.id + '"' : ''))
          .join(',')})`,
      };

      smartHttp
        .get(Endpoints.accountApi, queryParams)
        .then((res) => {
          setAccountsData(res.data?.results);
        })
        .catch((err) => {});
    } else {
      setAccountsData([]);
    }
  };

  const handleTabSelect = (tabName) => {
    if (window.location.pathname !== UrlPath.userLocation) {
      navigate(UrlPath.userLocation);
    }
  };

  const onContractChangeHandler = (contracts) => {
    setTotalUserCount(); // reset user count on contract change
    setTotalLocationCount(); // reset location count on contract change
    setContractsResult(contracts);
    dispatch(addContract(contracts));
  };

  const onTabSelect = (key) => {
    setActiveTab(key);
  };

  return (
    <>
      {loading ? (
        <Loader type="scaleLoader" />
      ) : (
        <>
          <div className="row">
            <div className="col-lg-8 col-md-7">
              <span id="user-location-header" className="page-header">
                <span className=" breadcrumb-nav-wrapper">
                  <span className="cursor-pointer" onClick={handleTabSelect}>
                    Manage Users
                  </span>
                  {window.location.pathname === UrlPath.exportUsers ? (
                    <>
                      <span className="breadcrumb-nav">/ Export</span>
                      <span className="breadcrumb-nav" title={breadCrumbValue}>
                        {breadCrumbValue ? ` / ${breadCrumbValue}` : ''}
                      </span>
                    </>
                  ) : (
                    <>
                      &nbsp;<span>& Locations</span>
                      <span className="breadcrumb-nav" title={breadCrumbValue}>
                        {breadCrumbValue ? ` / ${breadCrumbValue}` : ''}
                      </span>
                    </>
                  )}
                </span>
              </span>
            </div>
            <div
              className={`col-lg-4 col-md-5${
                showContractDropdown && !isBPMReferral ? '' : ' d-none'
              }`}
            >
              <CommonDropdown
                mode="multi"
                enableSelectAll={true}
                enableSearch={true}
                defaultSelectAll={true}
                labelKeyName={getContractLabelKey()}
                ddOptionsKey="id"
                options={contractsResult}
                setOptions={onContractChangeHandler}
                ddName="contracts"
                ddPlaceHolder={
                  selectedCount === 0
                    ? 'Contracts: (0)'
                    : selectedCount === contractsResult.length
                    ? 'Contracts: All Contracts'
                    : `Contracts:`
                }
              />
            </div>
          </div>

          {/* Tab section */}
          <div>
            {window.location.pathname === UrlPath.exportUsers ? (
              <div className="tabs-main">
                <ExportUsers contracts={contractsResult} />
              </div>
            ) : (
              <div className="tabs-main">
                <Tabs
                  fill
                  justify
                  defaultActiveKey={usersTabName}
                  activeKey={activeTab}
                  onSelect={onTabSelect}
                >
                  <Tab
                    eventKey={usersTabName}
                    title={`Users ${
                      contractsResult.some((obj) => obj?.checked) &&
                      totalUserCount >= 0
                        ? `(${totalUserCount})`
                        : ''
                    }`}
                  >
                    <UserDetails
                      contracts={contractsResult}
                      accounts={accountsData}
                      contractDisplayOption={contractDisplayOption}
                      isViewerUser={isViewerUser}
                      activeTab={activeTab}
                      callBackTotalUsers={callBackTotalUsers}
                      isBPMReferral={isBPMReferral}
                      locationFilter={locationFilter}
                      clearLocationFilter={() => setLocationFilter(null)}
                    ></UserDetails>
                  </Tab>
                  {!isBPMReferral && (
                    <Tab
                      eventKey={locationsTabName}
                      title={`Locations ${
                        contractsResult.some((obj) => obj?.checked) &&
                        totalLocationCount >= 0
                          ? `(${totalLocationCount})`
                          : ''
                      }`}
                    >
                      <Locations
                        contracts={contractsResult}
                        contractDisplayOption={contractDisplayOption}
                        isCSAUser={isCSAUser}
                        activeTab={activeTab}
                        callBackLocationUsers={callBackLocationUsers}
                        onLocationUserCountClick={onLocationUserCountClick}
                      ></Locations>
                    </Tab>
                  )}
                </Tabs>
              </div>
            )}
          </div>
        </>
      )}
      <LocationMapping
        show={showLocationMapping}
        setShow={setShowLocationMapping}
        oldLocations={oldLocationsData}
        contractNumbers={oldLocationsContractNumbers}
      />
    </>
  );
};

export default UserLocationContainer;
